import React from "react";
import Load from "./svg/Load";

const Loading = () => {
  return (
    <div className="d-flex flex-column align-items-center py-5">
      <div className="svg reset wh-40">
        <Load />
      </div>
      <div className="title mt-3">Loading...</div>
      <div className="sub-title">Please wait while we load your data.</div>
    </div>
  );
};

export default Loading;
